import Modal from '../../../../../../../components/Modal'
import { useForm } from 'react-hook-form'
import * as S from './InsertBarcodeModal.styles'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { ButtonMui } from 'src/components/ButtonMui'
import { selectProduct } from 'src/features/stock-management/StockManagementSeletor'
import { InsertBarcodeParams } from 'src/features/stock-management/StockManagementTypes'
import { actions } from 'src/features/stock-management/StockManagementState'
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material'
import { useState } from 'react'
import { handleOnKeyDown } from 'src/utils/Form'

export default ({
  showModal, setShowModal,
}) => {
  const dispatch = useDispatch()
  const isLoading = useSelector((state) => state.app.isLoading)
  const product = useSelector(selectProduct)

  const [isDunChecked, setDunChecked] = useState<boolean>(false)

  const {
    handleSubmit, reset, register, formState: { errors },
  } = useForm<InsertBarcodeParams>()

  const cancelModal = () => {
    setShowModal(false)
    setDunChecked(false)
    reset()
  }

  const onSubmit = async (data: InsertBarcodeParams) => {
    const dataFormatted = { ...data, modelId: product?.modelId }

    dispatch(actions.insertNewBarcode(dataFormatted))
  }

  return (
    <Modal
      testId='modal-create-barcode'
      show={showModal}
      closedButton={false}
      title='Inserir Código de Barras'
      titleStyle={{ fontSize: '16px', letterSpacing: '1.5px' }}
      IconLeft={() => <S.PostIcon />}
      size='lg'
      body={(
        <S.BodyModal>
          <form onSubmit={handleSubmit((data) => onSubmit({ ...data, onSuccess: cancelModal }))}>
            <S.CustomText>{`Digite o código de barras que deseja inserir para o produto de ID modelo ${product?.modelId} `}</S.CustomText>
            <S.InputContainer>
              <S.CustomTextField
                id='barcode'
                name='barcode'
                autoComplete='off'
                inputProps={{ ...register('barcode', { required: 'Campo obrigatório' }), 'data-testid': 'input-barcode' }}
                onKeyDown={(event) => handleOnKeyDown(event, 'packQty', isDunChecked ? undefined : handleSubmit((data) => onSubmit({ ...data, onSuccess: cancelModal })))}
                error={!!errors.barcode}
                label='insertBarcode'
                helperText={errors.barcode?.message}
                autoFocus
              />
              <S.CheckboxContainer>
                <FormGroup
                  sx={{
                    paddingTop: '1rem',
                  }}
                >
                  <FormControlLabel
                    control={(
                      <Checkbox
                        checked={isDunChecked}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setDunChecked(event.target.checked)}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    )}
                    label='DUN'
                  />
                </FormGroup>
                {isDunChecked && (
                  <S.CustomPackQtyField
                    id='packQty'
                    name='packQty'
                    autoComplete='off'
                    inputProps={{
                      ...register('packQty', {
                        required: 'Campo obrigatório',
                        min: {
                          value: 2,
                          message: 'Códigos de barras do tipo "DUN" devem possuir caixaria maior que 1',
                        },
                        pattern: {
                          value: new RegExp('^[0-9]*$'),
                          message: 'Deve ser um número inteiro',
                        },
                      }),
                      'data-testid': 'pack-qty-test-id',
                    }}
                    onKeyDown={(event) => handleOnKeyDown(event, '', handleSubmit((data) => onSubmit({ ...data, onSuccess: cancelModal })))}
                    error={!!errors.packQty}
                    label='Caixaria'
                    helperText={errors.packQty?.message}
                    type='number'
                    fullWidth
                  />
                )}
              </S.CheckboxContainer>
            </S.InputContainer>
            <S.ContainerButton>
              <ButtonMui
                title='Confirmar'
                id='confirmButton'
                type='submit'
                testId='button-confirm-insert'
                bgColor='blue'
                hoverColor='darkBlueHover'
                letterColor='white'
                disabled={isLoading}
              />
              <ButtonMui
                title='Cancelar'
                onClick={cancelModal}
                testId='cancel-button-insert'
                bgColor='red'
                hoverColor='redHover'
                letterColor='white'
              />
            </S.ContainerButton>
          </form>
        </S.BodyModal>
        )}
    />
  )
}
